import { isPending } from "App/apiMiddleware";
import get from "lodash/get";
import join from "lodash/join";
import sortBy from "lodash/sortBy";
import { createSelector } from "reselect";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getSourceTaskIds = createSelector((state) => get(state, `[${NAMESPACE}].sourceTaskIds`), (sourceTaskIds) => sourceTaskIds);
export const getShow = createSelector((state) => get(state, `[${NAMESPACE}].show`), (show) => show);
export const getTitle = createSelector((state) => get(state, `[${NAMESPACE}].title`), (title) => title);
export const getInProgress = (state) => isPending(state, `${actionTypes.GET_TASKS_LOGS}_${join(sortBy(getSourceTaskIds(state)), "_")}`);
